import { useLanguagePairContext } from 'src/context/languagePair';
import { getTargetMessages } from 'src/utils/getTargetMessages';

export const useTargetMessages = <T>(localesWithMessages: Record<string, T>) => {
  const { targetLanguageLocale } = useLanguagePairContext();

  return getTargetMessages(localesWithMessages, targetLanguageLocale);
};
